import Swiper, { Navigation, Pagination, Thumbs } from "swiper";

const Lightbox = {
  el: null,

  lightboxTitle: $("body").find("h1").text(),

  loading: false,

  slider: null,
  slider_dom: null,

  init() {
    if ($(".opens-lightbox").length) {
      // Make slider in content
      Lightbox.gallery();
      // Load lightbox
      Lightbox.load();
      // Add events
      Lightbox.events();
    }
  },

  load() {
    // Request lightbox
    $.ajax({
      url: ajaxurl,
      data: {
        action: "lightbox",
      },
      type: "POST",
      dataType: "JSON",
    }).done((response) => {
      $(".main").append(response);
      Lightbox.el = $("#lightbox");
      Lightbox.slider_dom = Lightbox.el.find(".lightbox-slider");
    });
  },

  events() {
    // Close on X click
    $("body").on("click", ".lightbox-close", function (e) {
      e.preventDefault();
      Lightbox.close();
    });

    // Close on ESC key
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        Lightbox.close();
      }
    });

    // Close if clicked outside of image
    $("body").on("click", ".lightbox-body", function (e) {
      var container = Lightbox.el.find(".lightbox-container");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        Lightbox.close();
      }
    });

    // Expand image on click
    $("body").on("click", ".opens-lightbox img", function () {
      var galleryEl = $(this).closest(".opens-lightbox");
      var item = $(this).closest("[data-item]").data("item");
      Lightbox.open(galleryEl, item);
    });

    // Expand image on Expand click
    $("body").on("click", ".gallery__expand", function (e) {
      e.preventDefault();
      var galleryEl = $(this).closest(".gallery");
      var item = $(".swiper-slide-active", galleryEl).data("item");
      Lightbox.open(galleryEl, item);
    });
  },

  gallery() {
    $(".gallery--slider").each(function (index) {
      const galleryEl = $(this);
      const sliderEl = galleryEl.find(".gallery__slider");

      const thumbsEl = galleryEl.find(".thumbs__slider");

      if (thumbsEl.length) {
        var galleryThumbs = new Swiper(thumbsEl[0], {
          spaceBetween: 10,
          slidesPerView: 4,
          loop: false,
          freeMode: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,

          on: {
            init() {
              thumbsEl.addClass("thumbs__slider--loaded");
            },
          },
        });
      } else {
        var galleryThumbs = false;
      }

      // Init content slider
      const nav_prev = galleryEl.find(".swiper-button-prev");
      const nav_next = galleryEl.find(".swiper-button-next");

      new Swiper(sliderEl[0], {
        modules: [Navigation, Pagination, Thumbs],
        loop: thumbsEl.length ? false : true,
        slidesPerView: 1,
        spaceBetween: 0,

        navigation: {
          prevEl: nav_prev[0],
          nextEl: nav_next[0],
        },
        pagination: {
          el: galleryEl.find(".swiper-pagination")[0],
          type: "fraction",
        },
        thumbs: {
          swiper: galleryThumbs,
        },
        on: {
          init() {
            sliderEl.addClass("gallery__slider--loaded");
          },
        },
      });
    });
  },

  close() {
    // Destroy slider
    if (Lightbox.slider) {
      Lightbox.slider.destroy();
    }
    // Remove lightbox
    Lightbox.el.removeClass("lightbox--open");
    // Allow scroll
    $("html").removeClass("no-scroll");
  },

  open(galleryEl, item) {
    if (!Lightbox.loading) {
      Lightbox.loading = true;

      // Disable scroll
      $("html").addClass("no-scroll");
      Lightbox.el.addClass("lightbox--loading");

      // Adds slides to slider
      var images = galleryEl.attr("data-ids").split(",").map(Number);
      $.ajax({
        url: ajaxurl,
        data: {
          action: "lightbox_load_images",
          images: images,
        },
        type: "POST",
      }).done((response) => {
        if (response.success) {
          Lightbox.el.find(".lightbox-wrapper").html(response.data);
          // Load swiper on lightbox
          Lightbox.construct(galleryEl, item);
        }
      });
    }
  },

  construct(galleryEl, item = 0) {
    // Init slider
    var nav_prev = Lightbox.el.find(".swiper-button-prev");
    var nav_next = Lightbox.el.find(".swiper-button-next");
    var paginationEl = Lightbox.el.find(".swiper-pagination")[0];


    if (this.lightboxTitle.length) {
      $(".lightbox-header__title").text(this.lightboxTitle);
    }


    Lightbox.slider = new Swiper(Lightbox.slider_dom[0], {
      modules: [Navigation, Pagination],
      initialSlide: item,
      loop: true,
      zoom: {
        maxRatio: 3,
      },
      slidesPerView: 1,
      spaceBetween: 0,

      keyboard: {
        enabled: true,
      },
      navigation: {
        prevEl: nav_prev[0],
        nextEl: nav_next[0],
      },
      pagination: {
        el: paginationEl,
        type: "fraction",
      },
      on: {
        init() {
          // Open lightbox
          Lightbox.el.removeClass("lightbox--loading");
          Lightbox.el.addClass("lightbox--open");
          Lightbox.loading = false;
        },
      },
    });

    const sliderEl = galleryEl.find(".swiper");
    if (sliderEl.length && sliderEl[0].swiper) {
      Lightbox.slider.on("slideChange", function () {
        // Sync with content
        var slide_to = this.realIndex;
        sliderEl[0].swiper.slideToLoop(slide_to);
      });
    }
  },
};

export default Lightbox;
